import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from './provider';

/**
 * Fires Segment page() calls on every route change. Mounted inside the
 * BrowserRouter so useLocation is available. Renders nothing.
 */
export const PageTracker: React.FC = () => {
    const analytics = useAnalytics();
    const location = useLocation();

    useEffect(() => {
        analytics.page(location.pathname, {
            search: location.search || undefined,
        });
    }, [analytics, location.pathname, location.search]);

    return null;
};
